export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";

export const showModal = (result, message=null) => {
  return {
    type: SHOW_MODAL,
    payload: {result,message},
  };
};

export const hideModal = () => {
  return {
    type: HIDE_MODAL,
  };
};